import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeTrailingZeroes',
    standalone: true
})
export class RemoveTrailingZeroesPipe implements PipeTransform {
    transform(value?: string): string {
        if (!value) {
            return '';
        }
        return value.replace(/\,00(\s)/, '$1');
    }
}
